import React from "react"

import { Number } from "@tenforce/product-fields"

import { Labels } from "../../../../../util/Translations"
import { useAppSelector } from "../../../../../hooks"
import { GlobalState } from "../../../../../store"

import { ICheckListViewActions, IQuestion } from "../../.."

export interface Props extends IQuestion {
    contextMenuActions: ICheckListViewActions
}

export const NumberFieldValue = ({
    data,
    id,
    contextMenuActions: { updateSimpleValue },
    controls: { canEditValue },
}: Props): JSX.Element => {
    const currentValue = data as string

    const { ClickHereToEdit } = Labels

    const regionalDecimalSeparator = useAppSelector(
        (state: GlobalState) =>
            state.userFormattingSettings.numberFormat.decimalSeparator,
    )

    return (
        <Number
            value={parseInt(currentValue)}
            placeholder={ClickHereToEdit}
            isReadOnly={!canEditValue}
            fieldId="numberAnswer"
            isLoading={false}
            onSave={(value): void => {
                updateSimpleValue(id, value === null ? "" : value.toString())
            }}
            regionalDecimalSeparator={regionalDecimalSeparator}
        />
    )
}

export default NumberFieldValue
